export enum ReportTypeEnum {
  GEORGIA_IMPORT_REPORT = 'Georgia Import Report',
  VDA_CLIENT_REPORT = 'VDA Client Report',
  VDA_INTERNAL_REPORT = 'VDA Internal Report',
  CONNECTICUT_OS114 = 'Connecticut OS-114',
}

export enum RelatedEntityTypeEnum {
  FILING = 'FILING',
  REGISTRATION = 'REGISTRATION',
  ORGANIZATION = 'ORGANIZATION',
  FILING_BATCH = 'FILING_BATCH',
}

export enum StoredReportStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  DONE = 'DONE',
  FAILED = 'FAILED',
}

export interface ReportsRead {
  id: string;
  report_type: ReportTypeEnum;
  s3_object_name: string | null;
  related_entity_id: string;
  related_entity_type: RelatedEntityTypeEnum;
  status: StoredReportStatus;
}

/**
 * Envelope returned by the async enhanced-filing-data endpoint, discriminated by
 * `status`. `data` holds the precomputed payload only when `status === DONE`.
 * `TData` lets consumers narrow the payload shape (e.g. `EnhancedData`).
 */
export interface EnhancedFilingDataArtifactResponse<TData = unknown> {
  status: StoredReportStatus;
  report_id: string | null;
  data: TData | null;
}

export interface AdminReportBuildRequest {
  related_entity_id: string;
  related_entity_type: RelatedEntityTypeEnum;
  queue_payload?: Record<string, unknown>;
}

export interface AdminReportBuildResponse {
  id: string;
}

export interface AdminReportDownloadResponse {
  url: string;
  filename: string;
}

export interface TransactionReportParams {
  report_type: string;
  country_code?: string;
  country_codes?: string[];
  state_code?: string;
  start_date: string;
  end_date: string;
  include_invalid_addresses?: string;
  source?: string;
  connection_ids?: string[];
  product_ids?: string[];
}

export type TransactionReportByProductsParams = Omit<TransactionReportParams, 'report_type'>;
